<template>
  <div class="flex flex-col w-full h-full">
    <div class="flex flex-row gap-1 pr-4 sm:px-8 py-3 w-full justify-end items-center">
      <button
        @click="setActiveSetting('UserRoles')"
        class="flex flex-row justify-center items-center px-2 py-1 bg-gray-400 rounded-md">
        <i class="material-icons text-lg text-white mr-1">manage_accounts</i>
        <span class="text-xs text-white">Izin Akses</span>
      </button>
      <button
        @click="setActiveSetting('Users')"
        class="flex flex-row justify-center items-center px-2 py-1 bg-gray-400 rounded-md">
        <i class="material-icons text-lg text-white mr-1">groups</i>
        <span class="text-xs text-white">Pengguna</span>
      </button>
    </div>
    <div class="overflow-hidden w-ful h-full">
      <component :is="ComponentMenuSetting"></component>
    </div>
  </div>
</template>

<script>
import TableUserRoles from './TableUserRoles.vue'
import TableUsers from './TableUsers.vue'

export default {
  name: 'MenuSetting',
  data: () => ({
    activeSetting: 'UserRoles'
  }),
  computed: {
    ComponentMenuSetting: function () {
      if (this.activeSetting === 'UserRoles') return TableUserRoles
      if (this.activeSetting === 'Users') return TableUsers
    }
  },
  methods: {
    setActiveSetting: function (name) {
      this.activeSetting = name
    }
  }
}
</script>
